// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gift-form-card[data-v-863a9aa0]{overflow:hidden;border:1px solid rgba(0,0,0,.06)}.form-header[data-v-863a9aa0]{background:linear-gradient(135deg,#3949ab,#5c6bc0 50%,#7986cb)}.header-icon-wrapper[data-v-863a9aa0]{width:48px;height:48px;border-radius:12px;background:hsla(0,0%,100%,.2);display:flex;align-items:center;justify-content:center}.save-btn[data-v-863a9aa0]{font-weight:700;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
